import { UseKlydoMutationOptions } from "../../../components/hooks/useKlydoMutation";
import uploadsApiClient, {
  UploadFileInput,
  UploadResponse,
} from "../../../api/uploads";
import useUploadMutation from "./useUploadMutation";

const useUploadCollectionLogotypeMutation = (
  options: Omit<
    UseKlydoMutationOptions<
      UploadResponse,
      UploadFileInput,
      { previousUploadStatus: UploadResponse | undefined }
    >,
    "onSuccess" | "onSettled"
  > & {
    onSuccess?: (response: UploadResponse) => void;
    onSettled?: (response: UploadResponse | undefined, error: unknown) => void;
  } = {},
) => {
  return useUploadMutation(
    uploadsApiClient.uploadCollectionLogotype,
    "upload-collection-logotype",
    options,
  );
};

export default useUploadCollectionLogotypeMutation;
